import {useMutation} from '@apollo/react-hooks';

import type {
    MeetingDeleteInput,
    DeleteManagedMeetingTemplate as DeleteManagedMeetingTemplateMutation,
    DeleteManagedMeetingTemplateVariables as DeleteManagedMeetingTemplateMutationVariables,
    GetManagedMeetingsTemplates as GetManagedMeetingsTemplatesQuery,
} from 'nutshell-graphql-types';

import GET_MANAGED_MEETINGS_TEMPLATES from '../../../graphql/queries/get-managed-meetings-templates.graphql';

import DELETE_MANAGED_MEETING_TEMPLATE from '../mutations/delete-managed-meeting-template.graphql';

export function useDeleteManagedMeetingTemplate(
    archived: boolean
): (arg1: MeetingDeleteInput) => Promise<any> {
    const [deleteMeeting] = useMutation<
        DeleteManagedMeetingTemplateMutation,
        DeleteManagedMeetingTemplateMutationVariables
    >(DELETE_MANAGED_MEETING_TEMPLATE);

    return (deleteInput: MeetingDeleteInput) => {
        return deleteMeeting({
            variables: {input: deleteInput},
            update: (proxy, mutationResults) => {
                const cacheResult: GetManagedMeetingsTemplatesQuery | null | undefined =
                    proxy.readQuery({
                        query: GET_MANAGED_MEETINGS_TEMPLATES,
                        variables: {archived},
                    });

                const deletedMeeting =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.meetingDelete &&
                    mutationResults.data.meetingDelete.meeting;

                if (!deletedMeeting) return;

                if (cacheResult) {
                    proxy.writeQuery({
                        query: GET_MANAGED_MEETINGS_TEMPLATES,
                        variables: {archived},
                        data: {
                            managedMeetings: cacheResult.managedMeetings.filter(
                                (meeting) => meeting.id !== deletedMeeting.id
                            ),
                        },
                    });
                }
            },
        });
    };
}
